import { Box } from '@mui/material'
import React, { ReactNode } from 'react'

interface FlightContainerProps {
    children: ReactNode
    /** Drop the blue radial gradient — used when a full-width banner sits behind the hero. */
    hideGradient?: boolean
}

export const FlightContainer: React.FC<FlightContainerProps> = ({ children, hideGradient }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                width: '100%',
                px: { sm: 2, md: 3 },
                pb: { sm: 2, md: 1 },
                // Desktop: gradient stops at tabs bottom
                background: {
                    xs: 'none', // Mobile: no gradient on container
                    lg: hideGradient
                        ? 'none'
                        : `
                        radial-gradient(
                            ellipse 120% 100% at top center,
                            rgba(217, 233, 255, 0.8) 0%,
                            rgba(217, 233, 255, 0.3) 35%,
                            rgba(217, 233, 255, 0.1) 55%,
                            rgba(255, 255, 255, 0) 70%,
                            rgb(255, 255, 255) 100%
                        )
                    `
                },
                backgroundPosition: {
                    xs: 'auto',
                    lg: 'top center'
                },
                backgroundRepeat: {
                    xs: 'repeat',
                    lg: 'no-repeat'
                }
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    maxWidth: { xs: '100%', md: 'none' },
                    border: { xs: 1, lg: 0 },
                    borderColor: { xs: 'grey.200', lg: 'none' },
                    borderRadius: { xs: '18px', md: 0 },
                    boxShadow: { xs: '0 2px 8px rgba(0, 0, 0, 0.06)', lg: 'none' },
                    p: { xs: 0, md: 0 },
                    mx: { xs: 2, md: 0 },
                    px: { md: 3, lg: 4 },
                    pb: { xs: 3, lg: 1 }
                }}
            >
                {children}
            </Box>
        </Box>
    )
}
